import { required, minLength, maxLength } from "react-admin";

export const validateName = [required(), minLength(2), maxLength(40)];
